const api_prefix_v2 = 'customer/v2/canteen';
const api = {
  employeeInfo: api_prefix_v2 + '/employee/info',
  employeePair: api_prefix_v2 + '/employee/pair',
  activateCard: api_prefix_v2 + '/employee/activate_card',
  customerCouponPage: (pageNo, pageSize) => api_prefix_v2 + `/customer_coupon/page?pageNo=${pageNo || 0}&pageSize=${pageSize || 10}`,
  customerCouponInfo: id => api_prefix_v2 + '/customer_coupon/info?id=' + id,
}
export default api